import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';

export const PricingSection = ({ onOpenPopup }) => {
  const plans = [
    {
      name: "Attorney Package",
      price: "$499",
      features: [
        "Case Review & Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "100% Satisfaction & Approval Guaranteed",
        "Refusal Risk Meter",
        "Trademark Monitoring (12 months)",
        "Complete Documentation",
        "Non Final Action Response Filing",
        "Dedicated IP Attorney",
        "Comprehensive Trademark Search Report (Federal & State)",
        "24 Hrs. Expedited Service",
        "Cease & Desist Letter",
        "IP Attorney 24/7 support"
      ],
      note: 'Govt. filing fee not included',
      popular: false,
    },
    {
      name: "Abandoned Application Package",
      price: "$599",
      features: [
        "Case Review & Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "100% Satisfaction & Approval Guaranteed",
        "Refusal Risk Meter",
        "Trademark Monitoring (12 months)",
        "Complete Documentation",
        "Non Final Action Response Filing",
        "Response to Abandonment of Application",
        "Statement of Use Filing",
        "Dedicated IP Attorney",
        "Comprehensive Trademark Search Report (Federal & State)",
        "24 Hrs. Expedited Service",
        "Cease & Desist Letter",
        "IP Attorney 24/7 support"
      ],
      note: 'Govt. filing fee not included',
      popular: true,
    },
  ];

  return (
    <section className="py-12 md:py-20 bg-white" data-testid="pricing-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-sm font-medium tracking-widest uppercase text-[#E1A334] mb-4 block">
              Transparent Plans
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-900 mb-4">
              Select Your Protection Package
            </h2>
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              Pick the plan that best matches your trademark protection requirements
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`relative flex flex-col bg-white rounded-3xl p-8 shadow-lg border-2 transition-all duration-300 hover:shadow-2xl ${plan.popular ? 'border-[#E1A334] shadow-[#E1A334]/10' : 'border-slate-100'
                }`}
              data-testid={`pricing-plan-${index}`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-[#E1A334] text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Recommended
                  </span>
                </div>
              )}

              <div className="mb-6">
                <h3 className="font-heading font-bold text-2xl text-slate-900 mb-2">
                  {plan.name}
                </h3>
                <p className="text-slate-500 text-sm mb-4">{plan.tagline}</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-bold text-slate-900">{plan.price}</span>
                 
                </div>
              </div>

              <div className="flex-1 mb-6">
                <div className="space-y-3 max-h-64 overflow-y-auto pr-2">
                  {plan.features.map((feature, fIndex) => (
                    <div key={fIndex} className="flex items-start gap-3">
                      <div className="bg-[#E1A334]/10 rounded-full p-1 mt-0.5 flex-shrink-0">
                        <Check className="h-3 w-3 text-[#E1A334]" />
                      </div>
                      <span className="text-slate-600 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="space-y-3">
                {/* <p className="text-xs text-slate-500 italic">{plan.note}</p> */}
                <Button
                  onClick={onOpenPopup}
                  data-testid={`pricing-button-${index}`}
                  className={`w-full h-12 font-semibold rounded-full transition-all duration-300 ${plan.popular
                    ? 'bg-[#E1A334] hover:bg-[#C4912E] text-white shadow-lg'
                    : 'bg-white text-slate-900 border-2 border-slate-200 hover:bg-slate-50'
                    }`}
                >
                  Get Started
                </Button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
